const Articles = () =>{
    return(
        <>
        <h6>Артикли в английском языке</h6>
        <p>
            В английском языке есть два типа артикля: определенный и неопределенный. Они не переводятся на русский язык. Перед существительным в единственном числе в подавляющем большинстве случаев надо ставить какой-то из этих артиклей.
            <br/><br/>
            Неопределенный артикль a/an используется только с исчисляемыми существительными в единственном числе: a girl (девочка), a pen (ручка). Если слово начинается с согласного звука, мы пишем артикль a (a girl), а если слово начинается с гласного звука, ставим артикль an (an apple).
        </p>
        <h5>Неопределенный артикль <span className=" text-fuchsia-600">a/an</span> употребляется в следующих случаях:</h5>
        <ul>
            <li>
                Мы называем любой, какой-то неопределенный предмет, причем он у нас один, поэтому мы и используем артикль a, который произошел от слова one (один):
                <br/><br/>
                <span className="example">It is a book. — Это книга.</span>
                <br/><br/>
            </li>
            <li>
                Мы впервые упоминаем предмет в речи:
                <br/><br/>
                <span className="example">I see a shop. — Я вижу (какой-то, один из множества) магазин.</span>
                <br/><br/>
            </li>
            <li>
                Мы говорим о профессии человека или указываем на его принадлежность к какой-то группе:
                <br/><br/>
                <span className="example">He is a teacher. — Он учитель.<br/><br/>She is a student. — Она студентка.</span>
                <br/><br/>
            </li>
        </ul>
        <p>
            Определенный артикль the мы ставим, когда речь идет о конкретном знакомом нам предмете. Этот артикль может стоять перед существительным в единственном или множественном числе.
        </p>
        <h5>Определенный артикль <span className=" text-fuchsia-600">the</span> употребляется в следующих случаях:</h5>
        </>
    )
}
export default Articles